// Libs
import classNames from 'classnames/bind';
import { useContext } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
import { BaseInput } from '~/components/common';
// Others
import { LoadingContext } from '~/context';
import { forgotPassword } from '~/thunks/auth/authThunk';
import { VerifyTypeEnum } from '~/utils/enum/common';
import { useAppDispatch } from '~/utils/redux/hooks';
import { authRouteAbsolute } from '~/utils/routes/auth';
import { IFormForgotPassword } from '~/utils/interface/auth';
import { defaultValuesForm, schema } from '~/pages/common/forgotPassword/helper';
// Styles, images, icons
import styles from './ForgotPassword.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const ForgotPassword = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/auth']);
  const loadingContext = useContext(LoadingContext);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormForgotPassword>({
    resolver: yupResolver(schema(t)),
    defaultValues: defaultValuesForm,
  });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleSubmitFormForgotPassword = (data: IFormForgotPassword) => {
    loadingContext?.show();

    dispatch(forgotPassword(data))
      .unwrap()
      .then((resp) => {
        if (!resp.data) return;

        const { accountId } = resp?.data;
        navigate(`${authRouteAbsolute.verifyCode}?id=${accountId}&type=${VerifyTypeEnum.FORGOT_PASSWORD}`);
      })
      .catch((_error) => {})
      .finally(() => {
        loadingContext?.hide();
      });
  };
  //#endregion Handle Function

  return (
    <Box
      id='forgotPasswordCommonPage'
      className={cx('container')}
      component={'form'}
      onSubmit={handleSubmit(handleSubmitFormForgotPassword)}
    >
      <Typography className={cx('formTitle')}>{t('forgot_password_title')}</Typography>

      <Stack direction={'column'} spacing={'30px'}>
        <Controller
          name='email'
          control={control}
          render={({ field: { value, onChange } }) => (
            <BaseInput
              height={50}
              required
              label={t('forgot_password_label_email')}
              value={value}
              onChange={onChange}
              errorMessage={errors?.email?.message}
            />
          )}
        />

        <Button variant='contained' className={cx('formBtn')} type='submit' size='large'>
          {t('forgot_password_btn_send')}
        </Button>
      </Stack>
    </Box>
  );
};

export default ForgotPassword;
